<template>
  <v-bottom-sheet
    inset
    max-width="600px"
    scrollable
    v-model="subtitlesPresetStore.managePresets"
  >
    <SubtitlesPresetsCard />
  </v-bottom-sheet>
</template>

<script>
import { useSubtitlesPresetStore } from "@/stores/subtitles-preset";
import SubtitlesPresetsCard from "@/components/edit/SubtitlesPresetsCard.vue";

export default {
  name: "ShortDetailBottomSheet",
  components: {
    SubtitlesPresetsCard,
  },
  setup() {
    const subtitlesPresetStore = useSubtitlesPresetStore();
    return { subtitlesPresetStore };
  },
};
</script>

<style scoped>
:deep(.v-bottom-sheet),
:deep(.v-bottom-sheet .v-card) {
  border-radius: 16px 16px 0 0;
}
</style>